<div class="row page-header">
    <div class="col-12">
        <h1>Equipment Priority &amp; Skills <small>Sub-category priorities, skill categories, and tech capabilities</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" class="nav-tabs">
        <li [ngbNavItem]="0">
            <a ngbNavLink>Sub-Category Priority</a>
        </li>
        <li [ngbNavItem]="1">
            <a ngbNavLink>Skill Categories</a>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Tech Role Capabilities</a>
        </li>
    </ul>

    <div class="row" style="margin-top: 10px" [hidden]="activeTab !== 0">
        <h5>Set optional priority (1–5) per Viewpoint equipment sub-category</h5>
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="priorityGrid" [name]="'Equipment sub-category priorities'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="priorityGrid"
                        #priorityGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(priorityGrid)"
                        (destroy)="grid.destroy()"
                        (cellEditEnded)="cellEditEnded(priorityGrid, $event)"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Category code'"
                            [binding]="'categoryCode'"
                            [width]="130"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Description'"
                            [binding]="'description'"
                            [width]="280"
                            [minWidth]="280"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Priority'"
                            [binding]="'priority'"
                            [dataMap]="priorityDataMap"
                            [width]="100"
                            [isReadOnly]="!canEdit"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 10px" [hidden]="activeTab !== 1">
        <h5>Skill categories used on equipment issue reports</h5>
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="skillCategoryGrid"></action-toolbar-count>
                        <action-toolbar-search name="skillSearch" [(ngModel)]="skillCategoryGrid.filter"></action-toolbar-search>
                        @if (canEdit) {
                            <button type="button" class="btn btn-primary btn-sm ms-2" (click)="addSkillCategory()">Add category</button>
                            <button type="button" class="btn btn-success btn-sm ms-2" (click)="saveSkillCategories()">Save all</button>
                        }
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="skillCategoryGrid"
                        #skillCategoryFlexGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="skillCategoryGrid.initialize(skillCategoryFlexGrid)"
                        (destroy)="skillCategoryGrid.destroy()"
                        (cellEditEnded)="skillCellEditEnded(skillCategoryFlexGrid, $event)"
                        [itemsSource]="skillCategoryGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Code'"
                            [binding]="'code'"
                            [width]="200"
                            [isReadOnly]="!canEdit"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Name'"
                            [binding]="'name'"
                            [width]="280"
                            [isReadOnly]="!canEdit"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sort'"
                            [binding]="'sortOrder'"
                            [width]="80"
                            [isReadOnly]="!canEdit"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Active'"
                            [binding]="'isActive'"
                            [dataMap]="activeDataMap"
                            [width]="90"
                            [isReadOnly]="!canEdit"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>

    <div class="row" style="margin-top: 10px" [hidden]="activeTab !== 2">
        <h5>Which tech roles can handle each skill category</h5>
        <div class="col-12 mb-3">
            @if (canEdit) {
                <button
                    type="button"
                    class="btn btn-success btn-sm"
                    [disabled]="!capabilityDirty"
                    (click)="saveCapabilities()"
                >
                    Save capability matrix
                </button>
            }
        </div>
        <div class="col-12 capability-grid-wrapper">
            <wj-flex-grid
                id="capabilityGrid"
                #capabilityFlexGrid
                (initialized)="onCapabilityGridInitialized(capabilityFlexGrid)"
                (destroy)="capabilityGrid.destroy()"
                (cellEditEnded)="capabilityCellEditEnded(capabilityFlexGrid, $event)"
                [itemsSource]="capabilityGrid.view"
            >
                <wj-flex-grid-filter></wj-flex-grid-filter>
            </wj-flex-grid>
        </div>

        <h5 class="mt-4">Mechanic → tech role assignments</h5>
        @if (canEdit) {
            <div class="row mb-2">
                <div class="col-md-4">
                    <label class="form-label">Mechanic</label>
                    <wj-combo-box
                        [itemsSource]="mechanicUserOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [(selectedValue)]="newAssignmentHrRef"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
                <div class="col-md-4">
                    <label class="form-label">Tech role</label>
                    <wj-combo-box
                        [itemsSource]="techRoleOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [(selectedValue)]="newAssignmentRoleId"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
                <div class="col-md-4 d-flex align-items-end">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addAssignment()">Add assignment</button>
                </div>
            </div>
        }
        <div class="col-12">
            <table class="table table-sm table-striped">
                <thead>
                    <tr>
                        <th>Mechanic</th>
                        <th>Tech role</th>
                        @if (canEdit) {
                            <th style="width: 100px"></th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of assignmentRows; track row.mechanicHrRef) {
                        <tr>
                            <td>{{ row.mechanicName }}</td>
                            <td>
                                @if (canEdit) {
                                    <wj-combo-box
                                        [itemsSource]="techRoleOptions"
                                        [displayMemberPath]="'display'"
                                        [selectedValuePath]="'value'"
                                        [(selectedValue)]="row.techRoleId"
                                        (selectedIndexChanged)="onAssignmentRoleChange(row)"
                                    ></wj-combo-box>
                                } @else {
                                    {{ row.techRoleName }}
                                }
                            </td>
                            @if (canEdit) {
                                <td>
                                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeAssignment(row)">
                                        Remove
                                    </button>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
